
(function headerDirectiveDefinition() {

    'use strict';

    angular.module('ui.Header')
        .directive('cppHeader', [
            'config',
            function navMenuDirective(config) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/directives/header/header.html'),
                    controller: [
                        '$scope', 'authExtend', 'navMenu', 'login', 'messages', 'userService','config',
                        function navMenuDirectiveController($scope, auth, navMenu, login, messages, userService, config) {
                            $scope.helpUrl = config.helpUrl();
                            $scope.customerCareUrl = config.customerCareUrl();
                            $scope.rightMargin = 400;
                          
                            $scope.updateUserLinkMode = function updateUserLinkMode() {
                                /*
                                if (auth.isLogged()) {
                                    userService.getLoguedUserById().then(function (r) {
                                        $scope.linkMode = r.optionUIID;
                                        if ($scope.linkMode === 4 || $scope.linkMode === 5) {
                                            auth.createTokenChangeApp().then(function (result) {
                                                auth.logout();
                                                window.location = config.custom('arandanoUrl') + "/#/login/" + result.token;
                                            });
                                        }
                                    });
                                }
                                */
                            };
                            
                            auth.onIdentityChanged(function identityChangedFn() {
                                $scope.userName = auth.getUserName();
                                $scope.userNick = auth.getUserNick();
                                $scope.updateUserLinkMode();
                                navMenu.update();
                            });

                            $scope.userName = auth.getUserName();
                            $scope.updateUserLinkMode();

                            $scope.logout = function navMenuDirectiveLogOut() {
                                login.logOut()
                                    .then(function () {
                                        $scope.userName = null;
                                        $scope.linkMode = null;
                                    },
                                        function () {
                                            messages.show($scope.logoutErrorText);
                                        });
                            };


                            $scope.$watch('linkMode', function (newValue, oldValue) {
                                if (newValue !== oldValue && (newValue === 2 || newValue === 3 || newValue === 5)) {
                                    userService.setRedirectOption(auth.getUserId(), newValue);
                                }
                            });
                        }
                    ]
                };
            }
        ]);

})();